import React from 'react';
import './styles.css';
import { HeaderProfile } from '@BUP/components';

const NoOrganizationPage = () => {
  return (
    <div className="no-organization-page-container">
      <HeaderProfile />
      <div className="message-wrapper">
        <h2>
          Lo sentimos, actualmente no perteneces a ninguna organización, <br />
          por favor contacta con tu proveedor.
        </h2>
      </div>
    </div>
  );
};

export default NoOrganizationPage;
